import React from 'react';
import { useModalContext } from '@fourthwall/components';
import { useUpdateEmailMutation } from '../mutations';
import { useOrderQuery } from '../queries';
import { OrderEmailView } from './OrderEmailView';
export const OrderEmailContainer = ({ orderId, initialValues }) => {
    const { invalidateOrderQuery } = useOrderQuery([{ orderId }]);
    const { close } = useModalContext();
    const { updateEmailMutation } = useUpdateEmailMutation({
        onSuccess: () => {
            invalidateOrderQuery();
        },
        onSettled: () => {
            close();
        },
    });
    const handleSubmit = async (values) => {
        await updateEmailMutation.mutateAsync([{ orderId, email: values.email }]);
    };
    return React.createElement(OrderEmailView, { initialValues: initialValues, onSubmit: handleSubmit });
};
